// Map Type Selector Component

import React from 'react';

interface MapType {
  label: string;
  value: string;
  icon: string;
}

interface MapTypeSelectorProps {
  selectedMapType: string;
  onMapTypeChange: (mapType: string) => void;
}

const MAP_TYPE_OPTIONS: MapType[] = [
  { label: 'OpenStreetMap', value: 'osm', icon: 'pi-map' },
  { label: 'OSM Night', value: 'osm_night', icon: 'pi-moon' },
  { label: 'Carto Light', value: 'carto_light', icon: 'pi-sun' },
  { label: 'Carto Dark', value: 'carto_dark', icon: 'pi-moon' },
  { label: 'Carto Voyager', value: 'carto_voyager', icon: 'pi-compass' },
  { label: 'Wikimedia', value: 'wikimedia', icon: 'pi-globe' },
  { label: 'CyclOSM', value: 'cyclosm', icon: 'pi-directions' },
  { label: 'Esri World', value: 'esri_world', icon: 'pi-image' },
  { label: 'Esri Street', value: 'esri_street', icon: 'pi-map-marker' },
];

export const MapTypeSelector: React.FC<MapTypeSelectorProps> = ({
  selectedMapType,
  onMapTypeChange
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const currentMapType = MAP_TYPE_OPTIONS.find(m => m.value === selectedMapType) || MAP_TYPE_OPTIONS[0];

  return (
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 1100 }}>
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        title="Harita Türü"
        style={{
          position: 'absolute',
          top: '70px',
          right: '20px',
          zIndex: 1100,
          background: 'white',
          border: '2px solid #e5e7eb',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
          transition: 'all 0.2s ease',
          pointerEvents: 'auto'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.background = '#f9fafb';
          e.currentTarget.style.borderColor = '#3b82f6';
          e.currentTarget.style.transform = 'scale(1.08)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(59, 130, 246, 0.3)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.background = 'white';
          e.currentTarget.style.borderColor = '#e5e7eb';
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
        }}
      >
        <span style={{ fontSize: '20px' }}>🗺️</span>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setIsOpen(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1099,
              pointerEvents: 'auto'
            }}
          />

          {/* Menu */}
          <div
            style={{
              position: 'absolute',
              bottom: '100px',
              right: '20px',
              zIndex: 1101,
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
              border: '2px solid #e5e7eb',
              minWidth: '200px',
              maxHeight: '350px',
              overflowY: 'auto',
              pointerEvents: 'auto'
            }}
          >
            {MAP_TYPE_OPTIONS.map((mapType) => (
              <button
                key={mapType.value}
                onClick={() => {
                  onMapTypeChange(mapType.value);
                  setIsOpen(false);
                }}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: 'none',
                  background: selectedMapType === mapType.value ? '#eff6ff' : 'white',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  fontSize: '14px',
                  fontWeight: selectedMapType === mapType.value ? '600' : '400',
                  color: selectedMapType === mapType.value ? '#2563eb' : '#374151',
                  transition: 'all 0.15s ease',
                  borderBottom: '1px solid #f3f4f6'
                }}
                onMouseOver={(e) => {
                  if (selectedMapType !== mapType.value) {
                    e.currentTarget.style.background = '#f9fafb';
                  }
                }}
                onMouseOut={(e) => {
                  if (selectedMapType !== mapType.value) {
                    e.currentTarget.style.background = 'white';
                  }
                }}
              >
                <i className={`pi ${mapType.icon}`} style={{ fontSize: '16px' }}></i>
                <span>{mapType.label}</span>
                {selectedMapType === mapType.value && (
                  <i className="pi pi-check" style={{ marginLeft: 'auto', fontSize: '14px' }}></i>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
